<template>
    <div class="page">
        <loadingS v-if='loading'></loadingS>
        <template v-else>
            <div class="banner">
                <div class="back_icon"
                     @click="goBack"></div>
            </div>
            <div class="tips">
                <p>班级内学生参与活动人数达到<span>20人及以上</span>，即可满足当月返金币条件</p>
            </div>
            <div class="list">
                <div class="item"
                     v-if="yw_list.length">
                    <div class="title">语文</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in yw_list"
                             :key="index">
                            <p class="unit_name">{{item.unit_name}}</p>
                            <div class="btn">
                                <span class="share"
                                      @click="share(item)">分享给学生</span>
                                <span @click="view(item)">查看参与情况</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item"
                     v-if="sx_list.length">
                    <div class="title">数学</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in sx_list"
                             :key="index">
                            <p class="unit_name">{{item.unit_name}}</p>
                            <div class="btn">
                                <span class="share"
                                      @click="share(item)">分享给学生</span>
                                <span @click="view(item)">查看参与情况</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item"
                     v-if="sf_list.length">
                    <div class="title">书法</div>
                    <div class="unit_list">
                        <div class="unit_item"
                             v-for="(item,index) in sf_list"
                             :key="index">
                            <p class="unit_name">{{item.unit_name}}</p>
                            <div class="btn">
                                <span class="share"
                                      @click="share(item)">分享给学生</span>
                                <span @click="view(item)">查看参与情况</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <div class="share_alert"
             v-if="show_share_alert">
            <div class="con">
                <p class="title">分享链接复制成功</p>
                <p class="text">在输入框中进行粘贴后，点击发送即可！</p>
                <span class="btn"
                      @click="close(1)">确定</span>
            </div>
        </div>
        <div class="unit_detail"
             v-if="show_detail">
            <div class="con">
                <img @click="close(2)"
                     src="./img/img_icon_05.png"
                     class="icon_close " />
                <div class="title">参与活动的学生</div>
                <div class="stu_list">
                    <p class="count">总共<span>{{stu_list.length}}</span>人</p>
                    <div class="name">
                        <span v-for="(item,index) in stu_list"
                              :key="index">{{item}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
import loadingS from 'SRC/components/base/loadingS.vue';
export default {
    components: {
        loadingS
    },
    data () {
        return {
            inApp: localStorage.getItem("search") && Number(JSON.parse(localStorage.getItem("search")).platform),
            loading: true,
            unitData: {},
            show_share_alert: false,
            show_detail: false,
            stu_list: [],
            yw_list: [],
            sx_list: [],
            sf_list: [],
        }
    },
    created () {
        //修改页面标题
        window.document.title = "开心学习，愉悦成长"
        this.$http.post(API_URL_HD_API + "/yycz2024/tea/index/").then(res => {
            res = res.data;
            if (res.response === 'ok') {
                this.yw_list = res.data.yw_list
                this.sx_list = res.data.sx_list
                this.sf_list = res.data.sf_list
            } else {
                layer.tips(res.message);
            }
        }).finally(() => { this.loading = false; })
    },
    methods: {
        goBack () {
            this.appFunction("ys_finish", "", 1);
        },
        view (unit) {
            console.log(unit)
            this.$http.post(API_URL_HD_API + "/yycz2024/tea/detail/", {
                unit_class_id: unit.unit_class_id,
                sid: unit.sid
            }).then(res => {
                res = res.data;
                if (res.response === 'ok') {
                    this.show_detail = true
                    this.stu_list = res.data
                } else {
                    layer.tips(res.message);
                }
            }).finally(() => { this.loading = false; })
        },
        share (unit) {
            let title = "开心学习，愉悦成长";
            let content = unit.school_name + "点击即可参与活动";
            if (this.inApp) {
                this.appFunction("ys_share", `${title},${content},${unit.short_url},${String(unit.sid)[0]},${unit.unit_class_id},0,26,期末大检测活动分享`);
            } else {
                this.show_share_alert = true
                this.copyText(`开心学习，愉悦成长,${unit.school_name}点击链接即可参与活动，链接：${unit.short_url}`)
            }
        },
        close (type) {
            if (type == 1) {
                this.show_share_alert = false
            } else if (type == 2) {
                this.show_detail = false
            }
        },
        copyText (text) {
            const input = document.createElement('input');
            input.setAttribute('readonly', 'readonly');
            input.setAttribute('value', text);
            document.body.appendChild(input);
            input.setSelectionRange(0, 9999);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
        },
    },
};
</script>

<style lang="scss" scoped>
.page {
    min-height: 757px;
    background-color: #fe2d03;
    padding-bottom: 20px / $ppr;
    .banner {
        height: 1052px / $ppr;
        background-size: 100% 100%;
        background-image: url("./img/banner.jpg");
        position: relative;
        .back_icon {
            top: 0;
            position: absolute;
            width: 86px / $ppr;
            height: 96px / $ppr;
            background-position: center;
            background-size: 18px / $ppr 34px / $ppr;
            background-repeat: no-repeat;
            background-image: url("./img/img_icon_01.png");
            cursor: pointer;
            opacity: 0.8;
        }
    }
    .tips {
        margin: -256px / $ppr 24px / $ppr 0;
        background: #ffefde;
        border-radius: 20px / $ppr;
        border: 3px / $ppr solid #fff;
        padding: 62px / $ppr 50px / $ppr;
        font-size: 30px / $ppr;
        color: #503700;
        line-height: 48px / $ppr;
        box-shadow: 0px 0px 12px / $ppr rgba(0, 133, 82, 0.1);
        position: relative;
        text-indent: 2em;
        span {
            color: #fb350a;
            font-weight: bold;
        }
    }
    .list {
        margin: 60px / $ppr 24px / $ppr 0;
        position: relative;
        .item {
            background: #ffefde;
            border-radius: 20px / $ppr;
            border: 2px / $ppr solid #fff;
            padding: 32px / $ppr 34px / $ppr 16px / $ppr;
            box-shadow: 0px 0px 12px / $ppr rgba(0, 133, 82, 0.2);
            margin-bottom: 60px / $ppr;
            .title {
                width: 309px / $ppr;
                height: 77px / $ppr;
                margin: -58px / $ppr auto 30px / $ppr;
                background: url("./img/title.png") no-repeat center;
                background-size: cover;
                text-align: center;
                font-size: 38px / $ppr;
                line-height: 77px / $ppr;
                color: #fb350a;
                font-weight: bold;
            }
            .unit_list {
                .unit_item {
                    padding: 38px / $ppr 18px / $ppr;
                    background: #fff;
                    border-radius: 12px / $ppr;
                    margin-bottom: 20px / $ppr;
                    display: flex;
                    justify-content: space-between;
                    align-content: center;
                    .unit_name {
                        font-size: 28px / $ppr;
                        line-height: 56px / $ppr;
                        color: #4c370d;
                        font-weight: bold;
                        padding-left: 20px / $ppr;
                    }
                    .btn {
                        display: flex;
                        align-items: center;
                        span {
                            padding: 0 18px / $ppr;
                            font-size: 24px / $ppr;
                            line-height: 56px / $ppr;
                            border-radius: 28px / $ppr;
                            background: #e84829;
                            color: #fff;
                            &.share {
                                background: #89bf19;
                                margin-right: 18px / $ppr;
                            }
                        }
                    }
                }
            }
        }
    }
}
.share_alert {
    background-color: $mask;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    .con {
        width: 600px / $ppr;
        background-color: #fff;
        border-radius: 20px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        .title {
            font-size: 32px / $ppr;
            font-weight: bold;
            color: #333;
            text-align: center;
            padding: 50px / $ppr 0 40px / $ppr;
        }
        .text {
            font-size: 28px / $ppr;
            color: #333;
            text-align: center;
            margin-bottom: 50px / $ppr;
        }
        .btn {
            display: block;
            line-height: 96px / $ppr;
            font-size: 30px / $ppr;
            color: #e84829;
            text-align: center;
            border-top: 1px / $ppr solid #eaeaea;
        }
    }
}
.unit_detail {
    background-color: $mask;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    .con {
        width: 600px / $ppr;
        background-color: #fff;
        border-radius: 20px / $ppr;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 20px;
        .icon_close {
            position: absolute;
            top: -60px / $ppr;
            right: 0;
            width: 40px / $ppr;
            height: 40px / $ppr;
        }
        .title {
            width: 100%;
            height: 109px / $ppr;
            line-height: 109px / $ppr;
            background: url("./img/title_bg.png") no-repeat center;
            background-size: cover;
            text-align: center;
            font-size: 36px / $ppr;
            font-weight: bold;
            color: #fff;
        }
        .stu_list {
            background: #fff;
            border-radius: 0 0 20px / $ppr 20px / $ppr;
            padding: 0 20px / $ppr 40px / $ppr 20px / $ppr;
            .count {
                font-size: 34px / $ppr;
                text-align: center;
                font-weight: bold;
                padding: 30px / $ppr 0;
                span {
                    color: #e84829;
                }
            }
            .name {
                margin-left: -5%;
                span {
                    width: 20%;
                    margin-bottom: 40px / $ppr;
                    display: inline-block;
                    margin-left: 5%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                }
            }
        }
    }
}
</style>